module.exports = __webpack_public_path__ + "img/2.79990f76.png";